import { buildCsvFromRows, escapeCsvCell } from '../../shared/csv-core/infra/buildCsv';
import type { ProductCatalogEventRow } from '../domain/catalogTypes';
import { getProductCatalogEventTypeLabel } from '../domain/catalogLabels';

export function buildProductCatalogHistoryCsv(params: {
  productName: string;
  rows: ProductCatalogEventRow[];
  actorLabel: (userId: string | null | undefined) => string;
  summaryForRow?: (row: ProductCatalogEventRow) => string;
}): string {
  const { productName, rows, actorLabel, summaryForRow } = params;
  const header = ['fecha_iso', 'tipo', 'resumen', 'usuario_actor', 'id_evento', 'producto'];
  const dataLines = rows.map((row) => [
    escapeCsvCell(row.createdAt),
    escapeCsvCell(getProductCatalogEventTypeLabel(row.eventType)),
    escapeCsvCell(summaryForRow ? summaryForRow(row) : (row.summary ?? '')),
    escapeCsvCell(actorLabel(row.performedByUserId)),
    escapeCsvCell(row.id),
    escapeCsvCell(productName),
  ]);
  return buildCsvFromRows(header, dataLines);
}
